// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2hvWO","inputWrap":"CustomTip_inputWrap__2x2rm"};